import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class FeeOptionRepository extends BaseRepository {
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/fee-options';
    }

    getAllForRestaurantHistory(restaurantHistoryId: number) {
        const path = "dashboard/admin/restaurant-histories/fee-options/" + restaurantHistoryId;
        return this.get(path);
    }

}
